














































import { LeadService } from "@/services/lead.service";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { required } from "@/shared/validators";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ComboCanalLead from "../components/ComboCanalLead.vue";
import ComboTipoLead from "../components/ComboTipoLead.vue";

@Component({
  components: { Modal, ComboTipoLead, ComboCanalLead },
})
export default class ImportarExcel extends mixins(GlobalMixin) {
  idCanalLead: number | null = null;
  idTipoLead: number | null = null;
  arquivo: File | null = null;
  loading = false;

  rules = {
    canalProspeccao: [required()],
    tipoLead: [required()],
    arquivo: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async importarExcel() {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async baixarModelo() {
    this.loading = true;
    await LeadService.importarLeadsExemplo("modelo-importacao.xlsx");
    this.loading = false;
  }

  async salvarImportacao() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      try {
        if (this.idTipoLead && this.idCanalLead) {
          await LeadService.importarLeads(
            this.arquivo!,
            this.idTipoLead,
            this.idCanalLead
          );
        }

        return modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
